import i18n from "../i18n";
import { isI18nInitialized } from "../i18n";
import TAUtils from "../ta_utils";
import TA_API from "../ta_api";
import ta_launcher from "../http_launcher_producer";
import PG from "../ta_pg";
import TA_INIT from "../ta_init";
import { executeOnUpgradeIgnored } from "./ta_upgrade_functions";

export default class TAUI {
  static hooks = {
    launch: undefined,
    launchFailed: undefined,
    download: undefined,
    downloadImage: undefined,
    manualUpdate: undefined,
  };

  /**
   * Download modal. This is meant to be shown when the transfer agent is being downloaded. It will show different
   * download screenshots to make sure people know where to find their download from the browser.
   *
   * @param {method} callback
   */
  static manualDownload = (isUpgrade, callback) => {
    let downloadImage = new Image();
    let downloadImageURL = "../../images/";
    let downloadImageURLLarge = "../../images/";
    let downloadImageStartSmall =
      '<img id="image-manualDownload" alt="' +
      i18n.t("webDeployment.manualDownloadTitle") +
      '" src="';
    let downloadImageStartLarge =
      '<img alt="' + i18n.t("webDeployment.manualDownloadTitle") + '" src="';
    let downloadImageEnd = '" />';

    switch (Browser.info().name) {
      case "chrome":
        downloadImageURL += "download_chrome_small.png";
        downloadImageURLLarge += "download_chrome_large.png";
        break;
      case "firefox":
        downloadImageURL += "download_firefox_small.png";
        downloadImageURLLarge += "download_firefox_large.png";
        break;
      case "ie":
        downloadImageURL += "download_ie_small.png";
        downloadImageURLLarge += "download_ie_large.png";
        break;
      case "edge":
        downloadImageURL += "download_edge_small.png";
        downloadImageURLLarge += "download_edge_large.png";
        break;
      case "safari":
        downloadImageURL += "download_safari_small.png";
        downloadImageURLLarge += "download_safari_large.png";
        break;
      default:
        downloadImageURL = "";
        downloadImageURLLarge = "";
        downloadImageStartSmall = "";
        downloadImageStartLarge = "";
        downloadImageEnd = "";
    }

    downloadImage.src = downloadImageURL;
    if (callback !== undefined) {
      downloadImage.addEventListener("load", function () {
        callback();
      });
    }
    TAUI.hooks.download = TAUI.dialog({
      message: isUpgrade
        ? i18n.t("webDeployment.manualDownloadMsg")
        : i18n.t("webDeployment.manualDownloadMsgForUpgrade") +
          "<br /><br />" +
          i18n.t("common.installDocIntro") +
          '<a href="' +
          TAUtils.getLinkForOS("installDoc") +
          '" id="revealDoc" target="_blank">' +
          i18n.t("common.installDocDescription") +
          "</a><br /><br />" +
          downloadImageStartSmall +
          downloadImageURL +
          downloadImageEnd,
      title: i18n.t("webDeployment.manualDownloadTitle"),
      className: "modal-manualDownload",
      closeButton: false,
      buttons: {},
    });

    $("#image-manualDownload").on("click", function () {
      // Open a larger dialog with a larger view of the image.
      TAUI.hooks.downloadImage = TAUI.dialog({
        message:
          downloadImageStartLarge + downloadImageURLLarge + downloadImageEnd,
        className: "modal-manualDownloadImage",
      });

      $(".modal-manualDownloadImage img").on("click", function () {
        TAUI.hooks.downloadImage.modal("hide");
      });
    });

    TAUtils.state.refreshWarning = true;
  };

  static handlers = {
    download: () => {
      if (TAUI.hooks.launch !== undefined) {
        TAUI.hooks.launch.modal("hide");
      }

      if (TAUI.hooks.launchFailed !== undefined) {
        TAUI.hooks.launchFailed.modal("hide");
      }

      if (TAUI.hooks.manualUpdate !== undefined) {
        TAUI.hooks.manualUpdate.modal("hide");
      }

      ta_launcher
        .pollHeartbeat()
        .then(() => {
          TAUI.hooks.download.modal("hide");
          TAUI.spinnerScreen(false, "waiting");
          window.location.reload(); // This may be incorrect?? How to let the React App know to reload?
        })
        .catch((err) => {
          TAUI.hooks.download.modal("hide");
          TAUI.spinnerScreen(false, "waiting");

          // needs a time buffer or will collide with closing
          // dialogs. In theory, could instead listen to the close
          // event on outstanding dialogs.
          setTimeout(function () {
            TAUI.launchFailed();
          }, 500);
        });

      TAUI.manualDownload(false, function () {
        // Make sure the download of the application happens after the modal loads (Safari-specific issue):
        window.location = TAUtils.getLinkForOS("download");
      });

      TAUI.spinnerScreen(true, "waiting");

      return false;
    },
  };

  static screenSpinnerQueue = [];

  static spinnerScreen = (makeVisible, type) => {
    isI18nInitialized.then(() => {
      let $spinContainer = $(".spinContainer");
      let $spinBack = $(".spinBack");

      if (typeof makeVisible === "undefined") {
        makeVisible = true;
      }
      if (typeof makeVisible === "string") {
        type = makeVisible;
        makeVisible = true;
      }

      if (makeVisible) {
        if ($spinContainer.length <= 0) {
          $spinContainer = $('<div class="spinContainer"/>');
          $spinBack = $('<div class="spinBack modal-backdrop in"/>');
          $spinBack.appendTo($spinContainer);
          $spinBack.after(
            '<div class="spinnerWidget"><div class="spinner"></div></div>'
          );
          $spinContainer.appendTo("body");
        } // only record and append new text instance if one doesn't already exist
        if (TAUI.screenSpinnerQueue.indexOf(type) === -1) {
          TAUI.screenSpinnerQueue.push(type);
          let titleSpinner = i18n.t("common.spinner." + type);
          if (titleSpinner === "") {
            titleSpinner = "Loading Resources";
          }
          $spinContainer
            .find(".spinner")
            .after(
              '<div class="spinnerText ' + type + '">' + titleSpinner + "</div>"
            );
        }
      } else {
        $spinContainer.find("." + type).remove();
        let typePos = TAUI.screenSpinnerQueue.indexOf(type);
        if (~typePos) TAUI.screenSpinnerQueue.splice(typePos, 1);
        if (TAUI.screenSpinnerQueue.length <= 0) {
          $spinContainer.remove();
        }
      }
    });
  };

  static alert = (msg) => {
    return bootbox.dialog({
      className: "fc-ta-dialog",
      message: msg,
      buttons: {
        ok: {
          label: "OK",
          callback: function () {},
        },
      },
    });
  };

  static dialog = (message, opts) => {
    let modal = undefined;
    if (typeof message === "object" && typeof opts === "undefined") {
      opts = message;
    }

    if (typeof opts === "undefined") {
      modal = TAUI.alert(message);
    } else {
      if (
        typeof opts.message === "undefined" ||
        opts.message === null ||
        opts.message === ""
      ) {
        opts.message = message;
      }
      // sanity check for existing identical dialog
      if (opts.className) {
        let $dialog = $("." + opts.className);
        if ($dialog.length > 0) {
          let $body = $dialog.find(".modal-body>div");
          if ($body.find(".dialogWarning").length <= 0) {
            $body.prepend(
              '<p class="alert alert-danger dialogWarning"><em>' +
                i18n.t("common.retryDialogMsg") +
                "</em></p>"
            );
          } else {
            let $numWarns = $body.find(".dialogRepeats");
            if ($numWarns.length <= 0) {
              $body
                .find(".dialogWarning")
                .prepend('(<span class="dialogRepeats">2</span>)');
            } else {
              let currentVal = parseInt($numWarns.text());
              currentVal++;
              $numWarns.text(currentVal);
            }
          }
        } else {
          opts.className += " fc-ta-dialog";
          modal = bootbox.dialog(opts);
        }
      }
    }

    // Returning reference to the modal we've created, so we don't have to look for it later.
    // Since this happens every time the modal is opened, the hook is self-updating.
    return modal;
  };

  static launchFailed = () => {
    let uniqueClass = "modal-launchFailed";
    let bodyMessage =
      '<p class="large-font-paragraph">' +
      i18n.t("common.warningLaunchFailed") +
      "</p>";

    if (TAUtils.detectOS() === "linux") {
      bodyMessage =
        '<p class="large-font-paragraph">' +
        i18n
          .t("common.warningLaunchFailedLinux")
          .replace("__refresh__", i18n.t("common.launchFailRefreshButton")) +
        "</p>";
    } else {
      bodyMessage += '<ul id="advancedOptionsSteps">';
      bodyMessage +=
        "<li>" + i18n.t("common.warningLaunchFailedReason1") + "</li>";
      bodyMessage +=
        "<li>" + i18n.t("common.warningLaunchFailedReason2") + "</li>";
      bodyMessage +=
        "<li>" + i18n.t("common.warningLaunchFailedReason3") + "</li>";
      bodyMessage +=
        "<li>" + i18n.t("common.warningLaunchFailedReason4") + "</li>";
      bodyMessage += "</ul>";
    }
    bodyMessage +=
      '<a class="collapsed" data-toggle="collapse" href="#advancedLaunch" aria-expanded="false"' +
      ' aria-controls="advancedLaunch">';
    bodyMessage +=
      i18n.t("common.manualLaunchAdvancedLabel") +
      ' <span class="caret"></span></a>';
    bodyMessage +=
      '<div class="panel-collapse collapse" id="advancedLaunch"><div class="well">';
    bodyMessage +=
      '<form class="form-horizontal"><div class="control-group"><fieldset><div class="control-group">' +
      '<label class="control-label" for="portValue">' +
      i18n.t("common.portNotFoundFieldLabel") +
      "</label>" +
      "&nbsp;&nbsp;" +
      '<input id="portValueRenew" name="portValueRenew" type="text" class="input-xlarge" value="' +
      TAUtils.getPortToListen() +
      '"></div></fieldset></div></form></div></div>';

    TAUI.spinnerScreen(false, "heartbeat");
    TAUI.spinnerScreen(false, "launch");

    let dialogOptions = {
      message: bodyMessage,
      title: i18n.t("common.agentNotFoundTitle"),
      className: uniqueClass,
      buttons: {
        download: {
          label: i18n.t("common.warningLaunchFailedReason1Link"),
          className: "btn-link btn-sm",
          callback: TAUI.handlers.download,
        },
        applyNewPort: {
          label:
            i18n.t("common.applyNewPort") +
            '&nbsp;&nbsp;<i class="fa fa-check" aria-hidden="true"></i>',
          className: "btn-warning btn-refresh btn-sm",
          callback: function () {
            TAUtils.setPortToListen($("#portValueRenew").val());
            window.location.reload(true);
            return false;
          },
        },
        refresh: {
          label:
            i18n.t("common.launchFailRefreshButton") +
            '&nbsp;&nbsp;<i class="fa fa-refresh"></i>',
          className: "btn-success btn-refresh btn-sm",
          callback: function () {
            location.reload();
            return false;
          },
        },
      },
    };

    // If we haven't downloaded before, reset the localStorage.
    if (TA_API.storage.transferAgent.downloads() < 1) {
      TAUtils.localStorageConfiguration.resetLocalStorage(
        "filecatalystLocalConfig"
      );
    }
    bootbox.hideAll();
    TAUI.hooks.launchFailed = TAUI.dialog(dialogOptions);
  };

  static download = (
    isUpgrade,
    executeAfterVersionCheck = () => true,
    upgradeIgnored = executeOnUpgradeIgnored
  ) => {
    PG.clearModals();

    // Start checking for heartbeat, but without launch. The installation
    // process, when successful and when selected by user, will do the launch.
    // Default duration is set in http_launcher.js
    if (!isUpgrade) {
      ta_launcher
        .pollHeartbeat()
        .then(function () {
          // AfterTA confirmed takes in executeAfterVersionCheck and executeIfUpgradeIgnored.
          // But if you are dpwnloadinf the TA you'd be downloading the latest one so default behaviour is okay.
          TA_INIT.afterTaConfirmed(executeAfterVersionCheck, upgradeIgnored);
          TAUI.taLaunchVisualCleanup();
        })
        .catch(function () {
          $(".modal-manualDownload").modal("hide");
          TAUI.launchFailed();
          // or see if there is a "installation timed out" type dialog
        });
    }

    // Show the download modal.
    TAUI.manualDownload(isUpgrade, function () {
      // Make sure the download of the application happens _after_ the modal loads (Safari-specific issue).
      // this is accomplished by sending the redirect as a callback to the manualDownload dialog:
      window.location = TAUtils.getLinkForOS("download");
    });

    TAUI.spinnerScreen(true, "waiting");

    return false;
  };

  static upgrade = (onEscape = () => true, onIgnore = () => true) => {
    // create an interactive dialog for when TransferAgent is not detected
    let uniqueClass = "modal-upgradeAgent";
    let bodyMessage =
      "<p>" +
      i18n.t("webDeployment.upgradeJSisNewer") +
      ' <a href="#" onclick="javascript: window.location.reload(true);">' +
      '<i class="fa fa-refresh"></i></a>' +
      "</p>";
    bodyMessage +=
      '<p><form class="form-horizontal">' +
      '<div class="control-group">' +
      '<label class="checkbox" for="noShowCheckbox">' +
      '<input type="checkbox" name="checkboxes" id="noShowCheckbox">' +
      i18n.t("webDeployment.doNotShowAgainCheckbox") +
      "</label>" +
      "</div>" +
      "</form></p>";
    let dialogOptions = {
      message: bodyMessage,
      title: i18n.t("webDeployment.upgradeTitle"),
      className: uniqueClass,
      onEscape: onEscape,
      buttons: {
        download: {
          label:
            i18n.t("webDeployment.agentNotFoundButtonDownload") +
            "&nbsp;&nbsp;" +
            PG.icon[PG.icon.currentset].download,
          className: "btn-info btn-download",
          callback: () => TAUI.download(true, onEscape, onIgnore),
        },
        ignore: {
          label:
            i18n.t("webDeployment.upgradeButtonIgnore") +
            "&nbsp;&nbsp;" +
            PG.icon[PG.icon.currentset].remove,
          className: "btn-danger btn-cancel",
          callback: onIgnore,
        },
      },
    };
    PG.dialog.hooks.upgrade = TAUI.dialog(dialogOptions);
  };

  // AfterTA confirmed takes in executeAfterVersionCheck and executeIfUpgradeIgnored.
  // if used from anywhere else but the login page. This call needs to be modiffied to take in
  // executeAfterVersionCheck and executeIfUpgradeIgnored so it can be passed to afterTaConfirmed.
  static launch = (
    executeAfterVersionCheck = () => true,
    upgradeIgnored = executeOnUpgradeIgnored
  ) => {
    TAUI.spinnerScreen(true, "heartbeat");

    // use the HTTP_Launcher instance to launch. If this has not
    // been initialized, we will fail. Need a way to check for status.
    // The user is confirming that they have installed TA, so whether
    // they are correct or not, reduce the default polling length to 20s
    ta_launcher
      .launch()
      .pollHeartbeat(20000)
      .then(function () {
        TA_INIT.afterTaConfirmed(executeAfterVersionCheck, upgradeIgnored);
        TAUI.taLaunchVisualCleanup();
      })
      .catch(function () {
        // if it didn't work, show dialog again
        TAUI.manualLaunch(executeAfterVersionCheck, upgradeIgnored);
      })
      .finally(function () {
        // no matter what, stop the spinner
        TAUI.spinnerScreen(false, "heartbeat");
      });

    PG.dialog.hooks.launch.modal("hide");

    // Don't close the modal. It is to be closed by the next successful heartbeat/poll.
    return false;
  };

  static manualLaunch = (
    executeAfterVersionCheck = () => true,
    upgradeIgnored = executeOnUpgradeIgnored
  ) => {
    let isLinux = TAUtils.detectOS() === "linux";
    let taPort = ta_launcher.getLocal("port");
    let dialogVisible = $(".modal-manualLaunch").length > 0 ? true : false;
    let browser = Browser.info().name;
    let uniqueClass = "modal-manualLaunch";
    let bodyMessage = "<p>" + makeLaunchMsg() + "</p>";

    if ($(".modal-manualDownload").length > 0) {
      // Our download modal is opened, so don't show the first one again.
      return;
    }

    /**
     * Assemble launch message.
     */
    function makeLaunchMsg() {
      let initMsg = i18n.t("webDeployment.manualLaunchMsg");
      // store links that may get used;
      let tryLink =
        '<a href="#" id="launchTryAgain">' +
        i18n.t("webDeployment.manualLaunchTryAgain") +
        "</a>";
      let downLink =
        '<a href="#" id="launchDownload">' +
        i18n.t("webDeployment.manualLaunchDownload") +
        "</a>";
      let installGuideLink =
        '<a href="' +
        TAUtils.getLinkForOS("installDoc") +
        '" id="revealDoc" target="_blank">' +
        i18n.t("common.installDocDescription") +
        "</a>";

      // select an appropriate manual launch message
      if (isLinux) {
        initMsg = i18n.t("webDeployment.manualLaunchMsgLinux");
      }

      let msg = initMsg
        .replace("__tryAgain__", tryLink)
        .replace("__download__", downLink);
      msg +=
        "<p>" + i18n.t("common.installDocIntro") + installGuideLink + "</p>";

      //wire up the click handlers.
      $(document).on("click", "#launchTryAgain", function (e) {
        e.preventDefault();
        TAUI.launch(executeAfterVersionCheck, upgradeIgnored);
      });

      $(document).off("click", "#launchDownload");
      $(document).on("click", "#launchDownload", function (e) {
        e.preventDefault();
        TAUI.download(false, executeAfterVersionCheck, upgradeIgnored);
      });

      $(document).off("change", "#portValue");
      $(document).on("change", "#portValue", function () {
        TAUtils.setPortToListen($(this).val());
      });

      return msg;
    }

    if (!dialogVisible) {
      // create an interactive dialog for manually configuring the TransferAgent
      if (browser === "ie" || browser === "edge") {
        bodyMessage +=
          "<p>" + i18n.t("webDeployment.internetExplorerConfig") + "</p>";
      }

      bodyMessage +=
        '<a data-toggle="collapse" href="#advancedLaunch" aria-expanded="false" aria-controls="advancedLaunch">' +
        i18n.t("webDeployment.manualLaunchAdvancedLabel") +
        ' <span class="caret"></span></a>' +
        '<div class="collapse" id="advancedLaunch"><div class="well"><form class="form-horizontal"><fieldset>' +
        '<div class="control-group"><label class="control-label" for="portValue">' +
        i18n.t("webDeployment.portNotFoundFieldLabel") +
        "</label>&nbsp;&nbsp;" +
        '<input id="portValue" name="portValue" type="text" class="input-xlarge" value="' +
        taPort +
        '"></div>' +
        "</fieldset></form></div></div>";

      let dialogOptions = {
        message: bodyMessage,
        title: i18n.t("webDeployment.manualLaunchTitle"),
        className: uniqueClass,
        closeButton: false,
        buttons: {},
      };

      // We don't show the launch button on Linux.
      if (!isLinux) {
        dialogOptions.buttons.launch = {
          label: i18n.t("webDeployment.manualLaunchButton"),
          className: "btn-link btn-confirm",
          callback: () => {
            TAUI.launch(executeAfterVersionCheck, upgradeIgnored);
          },
        };
      }

      dialogOptions.buttons.download = {
        label:
          i18n.t("webDeployment.agentNotFoundButtonDownload") +
          "&nbsp;&nbsp;" +
          PG.icon[PG.icon.currentset].download,
        className: "btn-success btn-download",
        callback: () =>
          TAUI.download(false, executeAfterVersionCheck, upgradeIgnored),
      };

      PG.dialog.hooks.launch = TAUI.dialog(dialogOptions);
    }
  };

  static taLaunchVisualCleanup = () => {
    $(".help-anchor").attr(
      "href",
      PG.baseUrl("help", undefined, true) + "help/TransferAgent/help.html#webui"
    );
    $(".modal-manualLaunch").modal("hide");
    $(".modal-manualDownload").modal("hide");
    TAUI.spinnerScreen(false, "heartbeat");
    TAUI.spinnerScreen(false, "waiting");
    TAUI.spinnerScreen(false, "initializing");
  };

  static growl = (message, placeHolderMap, options) => {
    isI18nInitialized.then(() => {
      const translatedMessage = i18n.t(`${message}`, placeHolderMap);
      console.log(`Translated message is : ${translatedMessage}`);
      $.notify({ message: translatedMessage }, { ...options });
    });
  };
}
